import React from 'react';

const EmiIcon = (props) => (
  <img {...props} src={require('../../assets/emi.svg')}/>
)

export default EmiIcon
